/**
 * Tram detection
 * - used in Olsztyn
 */

import Color from '../color.es6'
import Ren from '../ren-shape.es6'
import Element from './element.es6'
import Geo from '../geometrics.es6'

export default class Tc extends Element {
  setDefaultShapes () {
    if (this.elementTypeName === 'Tc_ttc_left') {
      this.shapes.push(
        new Ren.Line({
          name: 'tc',
          points: [0, -15, 0, -30, -30, -30, -15, -15],
          lineCap: 'round',
          strokeEnabled: false,
          closed: true,
          fill: Color.offlineGray,
          opacity: 0.5
        }),
        new Ren.Line({
          name: 'stroke',
          points: [0, -15, 0, -30, -30, -30, -15, -15],
          lineCap: 'round',
          strokeWidth: 0.5,
          closed: true,
          opacity: 0.8
        })
      )

      // fix online status position
      this.modifyShape('onlineStatus', 'x', -15)
      this.modifyShape('onlineStatus', 'y', -40)
    }

    if (this.elementTypeName === 'Tc_ttc_right') {
      this.shapes.push(
        new Ren.Line({
          name: 'tc',
          points: [0, -15, 0, -30, 30, -30, 15, -15],
          lineCap: 'round',
          strokeEnabled: false,
          closed: true,
          fill: Color.offlineGray,
          opacity: 0.5
        }),
        new Ren.Line({
          name: 'stroke',
          points: [0, -15, 0, -30, 30, -30, 15, -15],
          lineCap: 'round',
          strokeWidth: 0.5,
          closed: true,
          opacity: 0.8
        })
      )

      // fix online status position
      this.modifyShape('onlineStatus', 'x', +15)
      this.modifyShape('onlineStatus', 'y', -40)
    }

    if (this.elementTypeName === 'Tc_vector') {
      const strokePoints = Geo.getStrokePoints(this.points)

      this.shapes.push(
        new Ren.Line({
          name: 'line',
          points: this.points,
          stroke: Color.black,
          strokeWidth: 2,
          opacity: 0.5
        }),
        new Ren.Line({
          name: 'tc',
          points: strokePoints,
          strokeEnabled: false,
          closed: true,
          fill: Color.offlineGray,
          opacity: 0.5
        }),
        new Ren.Line({
          name: 'stroke',
          points: strokePoints,
          strokeWidth: 0.5,
          closed: true,
          opacity: 0.8
        })
      )

      // fix online status position
      const { x, y }  = this.getAvgPoint(this.points)
      this.modifyShape('onlineStatus', 'x', x)
      this.modifyShape('onlineStatus', 'y', y)
    }
  }

  applyStatusOnShapes (newVariables, deviceTypes) {
    const status = newVariables || this.status
    super.applyStatusOnShapes(newVariables)
    // occupied
    if (status.occupied) {
      this.modifyShape('tc', 'opacity', 0.8)
      this.modifyShape('tc', 'fill', Color.tYellow)
    } else {
      this.modifyShape('tc', 'opacity', 0.3)
      this.modifyShape('tc', 'fill', Color.tBlue)
    }
  }

  getAvgPoint (points) {
    let p = points.reduce((point, i, index) => {
      if (index % 2 === 0) {
        point.x+= i
      } else  {
        point.y+= i
      }
      return point
    }, { x: 0, y: 0 })

    return {
      x: Math.round(p.x / (points.length / 2)),
      y: Math.round(p.y / (points.length / 2))
    }
  }
}
